import { render, staticRenderFns } from "./MaengelList.vue?vue&type=template&id=056a85ab"
import script from "./MaengelList.vue?vue&type=script&lang=js"
export * from "./MaengelList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports